import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner } from 'react-bootstrap';

const VerifyEmployee = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    const verifyToken = async () => {
      const token = searchParams.get('token');

      if (!token) {
        setMessage('No verification token provided');
        setIsLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/employee/verify-employee?token=${token}`
        );
        
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || 'Employee verification failed');
        }

        setMessage(data.message || 'Employee account verified successfully!');
        setIsSuccess(true);
        
        // Redirect to login after 3 seconds
        setTimeout(() => navigate('/login'), 3000);
      } catch (error) {
        setMessage(error.message || 'Failed to verify employee account');
        setIsSuccess(false);
      } finally {
        setIsLoading(false);
      }
    };

    verifyToken();
  }, [searchParams, navigate]);

  return (
    <Container className="mt-5">
      <div className="text-center">
        <h2>Employee Account Verification</h2>
        {isLoading ? (
          <div className="my-4">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
            <p className="mt-2">Verifying your employee account...</p>
          </div>
        ) : (
          <Alert variant={isSuccess ? 'success' : 'danger'} className="mt-4">
            {message}
          </Alert>
        )}
      </div>
    </Container>
  );
};

export default VerifyEmployee;